import React from 'react';

import Menu from './parts/Menu';
import HeaderMoluna from './parts/HeaderMoluna';

import { PageMode } from './parts/Definitions';

import { reactUrlToBrowserUrl } from '../../../../urlParse';
import $ from 'jquery';

import './index.scss';
import Loading from './parts/Loading';
import BreadCrumb from './parts/BreadCrumb';
import FooterMoluna from './parts/FooterMoluna';
import CookieManager from './parts/CookieManager';
import ErrorBoundary from '../../ErrorBoundary';
import { replaceAllComplex, umcodeURL } from '../../../../mol_function';
import {
  basePageHeaderGetterOverrides,
  basePagePostBodyInjectionOverrides,
  childDidReMountAsyncOverrides,
  pageMasterTitle,
} from './overrides';

// renderChild() muss in einer eigenen Komponente laufen, damit die
// ErrorBoundary Fehler darin abfängt und Header/Menü/Footer stehen bleiben
const ChildRenderer = (props: { render: () => JSX.Element }) =>
  props.render();

interface BasePageProps {
  domainPrefix: string;
  searchSuggestParamInjection: string;
  articleCount: number;
  articlePreis: string;
  isLogin: boolean;
  securityToken: string;
  urlParams: string;
}

export interface BasePageState {
  mode: PageMode;
  hasApiData: boolean;
  apiData: any;
  queryParams: any;
  renderingDomain: string;
  apiBase: string;
}

export default abstract class Basepage<
  TState extends BasePageState,
  TModel,
> extends React.Component<BasePageProps, TState> {
  checkModeIntervalHandle: NodeJS.Timer;
  apiDataCoruptRestart: NodeJS.Timeout;

  abstract renderChild(): JSX.Element;
  abstract initState(base: BasePageState): TState;
  abstract getApiReqestUrl(): string;

  abstract childDidMount(): void;
  abstract childDidUnmount(): void;

  abstract initJSChild(): string;

  abstract childDidUpdate(prevProp: any, prevState: any): void;
  abstract getRightBreadCrumbParts(): JSX.Element;

  abstract pageHeaderGetter(): string | null;
  abstract pageTitleGetter(): string;

  mainContainer: React.Ref<HTMLDivElement>;
  body: TModel;

  constructor(props: any) {
    super(props);

    this.mainContainer = React.createRef();

    let hasApiData = props.apiData != null;
    let apiData = props.apiData;
    let apiUrl = props.apiUrl;
    let renderingDomain = props.renderingUrl;

    if (apiData != null) this.body = apiData.body;

    //TODO: initMode
    let initMode = PageMode.Desktop;
    let mode = props.initResolution;

    if (mode == 'Mobile') initMode = PageMode.Mobile;
    else if (mode == 'Tablet') initMode = PageMode.Tablet;

    let initState = this.initState({
      mode: initMode,
      hasApiData: hasApiData,
      apiData: apiData,
      queryParams: this.parseQueryParams(),
      renderingDomain: renderingDomain,
      apiBase: apiUrl,
    });

    this.state = initState;

    if (props.postRenderControl != null) {
      props.postRenderControl.headerInjection = this.basePageHeaderGetter();
      props.postRenderControl.title = this.getTitle();
      props.postRenderControl.postBodyInjection =
        basePagePostBodyInjectionOverrides();
    }
  }

  basePageHeaderGetter() {
    return basePageHeaderGetterOverrides() + this.pageHeaderGetter();
  }

  getTitle() {
    let masterTitel = pageMasterTitle();
    let subPageTitle = this.pageTitleGetter();
    if (subPageTitle != '') return subPageTitle + ' - ' + masterTitel;
    else return masterTitel;
  }

  parseQueryParams() {
    let queryParams: any = {};

    let dummyProps: any = this.props;
    let location = dummyProps.location;

    let searchPart = location.search;
    if (searchPart != null) {
      searchPart = searchPart.substring(1);
      let parts = searchPart.split('&');
      for (let i = 0; i < parts.length; i++) {
        let part = parts[i].trim();
        if (part != '') {
          let ptemp = part.split('=');
          queryParams[ptemp[0]] = decodeURI(ptemp[1]);
        }
      }
    }

    return queryParams;
  }

  componentDidUpdate(prevProp: any, prevState: any) {
    let dcp: any = this.props;
    let dPPl = prevProp.location;
    let dCPl = dcp.location;
    let dpl = dPPl.pathname + dPPl.search;
    let dcl = dCPl.pathname + dCPl.search;

    if (dpl != dcl) {
      if (this.apiDataCoruptRestart != undefined) {
        clearTimeout(this.apiDataCoruptRestart);
        this.apiDataCoruptRestart = undefined;
      }
      this.setState({
        apiData: null,
        hasApiData: false,
        queryParams: this.parseQueryParams(),
      });
      this.fetchApiData();
    }
    this.childDidUpdate(prevProp, prevState);
  }

  componentDidMount() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;

    s.innerHTML = this.getAsyncInitJS();
    document.getElementById('main-container')?.append(s);
    this.checkMode();
    //todo Remove on umount
    this.checkModeIntervalHandle = setInterval(() => {
      this.checkMode();
    }, 1000);
    this.childDidReMount();

    window.currentPage = this;

    if (!this.state.hasApiData) this.fetchApiData();
  }

  getAsyncInitJS() {
    return (
      ` function initJSBudle(){
        const s2 = document.createElement('script');
        s2.type = 'text/javascript';
        s2.async = true;
        s2.innerHTML = \`` +
      this.getInitJSInject() +
      `\` ;
        document.getElementById('main-container')?.append(s2);   
      }
      
      function checkReady(){
        
        if(typeof jQuery !==undefined && typeof $ !==undefined ){
          initJSBudle();
        }
        else{
          setTimeout(checkReady,100);
        }
      }
      checkReady();
    
    `
    );
  }

  getInitJSInject() {
    return (
      //this.getColorboxInitJS() +
      //this.getMobileMenuInitJS() +
      this.getSearchInitJS() + this.getTrustShopInitJS() + this.initJSChild()
    );
  }

  getMobileMenuInitJS() {
    return `
    $('#mobileMenuContainer').multilevelpushmenu({
      containersToPush: [$( '#main-container' )],
      mode: 'cover',
      backText: 'zurück',
      backItemIcon: 'fa fa-angle-left', 
      swipe: 'both'  ,
      preventItemClick: false,
      collapsed: true,
      onCollapseMenuEnd :()=>{
        document.getElementById("mobileMenuContainer").classList.add("mobileMenuCollapse");
      },
      onExpandMenuStart:()=>{
        document.getElementById("mobileMenuContainer").classList.remove("mobileMenuCollapse");
      },
      onItemClick:(a)=> {
        debugger;
        window.location.href = a.target.href;
      },
      onMenuReady:()=>{
        document.getElementById("mobileMenuContainer").classList.add("mobileMenuContainerReady");
        document.getElementById("mobileMenuContainer").classList.add("mobileMenuCollapse");
      }
    });
    `;
  }

  getColorboxInitJS() {
    return `$("a[rel^='colorbox']").colorbox({opacity:0.6,speed:400,initialWidth:250,initialHeight:250,overlayClose:true,loop:true,current:"{current} of {total}"});`;
  }

  getSearchInitJS() {
    let searchSuggestParamInjection = '';

    if (this.state?.apiData?.searchSuggestParamInjection != undefined) {
      searchSuggestParamInjection =
        this.state.apiData.searchSuggestParamInjection;
    }

    return (
      `
    $("#autosearch").autocomplete({
      source: function( request, response ) {
          $.ajax({
          url: "` +
      this.state.renderingDomain +
      `/searchsuggest/",
          data: { 
      q: ''+request.term+'*',
              fl: "Titel",
              wt: 'json',` +
      searchSuggestParamInjection +
      `
           }, 
           dataType: "jsonp",
           jsonp: 'json.wrf',

           success: function( data ) {
              response($.map(data.response.docs, function( item ) { 
                  return { 
                      label: item.Titel,
                      value: item.Titel,
                  }; 
          }));
          }
        }); 
       },
      minLength: 1
      });`
    );
  }

  getTrustShopInitJS() {
    let trustedResponsive =
      "{'variant': 'floating_reviews', 'position': 'right'}";
    let trustedcustomElementId = '';
    let variant = 'reviews';
    if (this.constructor.name == 'ShoppingCartPage') {
      trustedResponsive =
        "{'variant': 'custom_reviews', 'customElementId': 'trustbadgeCustomContainer'}";
      trustedcustomElementId = 'trustbadgeCustomContainer';
      variant = 'custom_reviews';
    }

    let trustetSnipped =
      `
    //<!-- Trusted Shop -->
  
    (function () {
      var _tsid = "XD1590B3300120FAA7CB5142D0FB49791";
      _tsConfig = {
        responsive: ` +
      trustedResponsive +
      `,
        yOffset: "0" /* offset from page bottom */,
        variant:  "` +
      variant +
      `" /* default, reviews, custom, custom_reviews */,
        customElementId: "` +
      trustedcustomElementId +
      `" /* required for variants custom and custom_reviews */,
        trustcardDirection:
          "bottomLeft" /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */,
        customBadgeWidth: "" /* for custom variants: 40 - 90 (in pixels) */,
        customBadgeHeight: "" /* for custom variants: 40 - 90 (in pixels) */,
        disableResponsive: "false" /* deactivate responsive behaviour */,
        disableTrustbadge: "false" /* deactivate trustbadge */,
      };
      var _ts = document.createElement("script");
      _ts.type = "text/javascript";
      _ts.charset = "utf-8";
      //_ts.async = true;
      _ts.setAttribute("data-cmp-vendor", "s1432");
      _ts.setAttribute(
        "data-cmp-src",
        "//widgets.trustedshops.com/js/" + _tsid + ".js"
      );
      _ts.className = "cmplazyload";

      //_ts.src = '//widgets.trustedshops.com/js/' + _tsid + '.js';
      var __ts = document.getElementsByTagName("script")[0];
      __ts.parentNode.insertBefore(_ts, __ts);
    })();
  //<!-- End Trusted Shop -->
  `;

    return trustetSnipped;
  }

  fetchApiData() {
    try {
      let anyWin: any = window;
      anyWin.scrollTo(0, 0);
    } catch {}

    let apiUrl = this.getApiReqestUrl();
    fetch(apiUrl, {
      headers: {
        //'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //Try Potect Load data Context
        //if (apiUrl == this.getApiReqestUrl()) {
        this.body = data.body;
        this.setState({ apiData: data, hasApiData: true });
        setTimeout(() => {
          this.childDidReMount();
        }, 500);
        //}
        /*
        else {
          setTimeout(() => {
            this.fetchApiData();
          }, 100);
        }
        */
      });
  }

  childDidReMount() {
    setTimeout(() => {
      let flickis = $('.js-flickity');

      for (let i = 0; i < flickis.length; i++) {
        let config = flickis[i].getAttribute('data-flickity-options');
        if (config != null) {
          try {
            config = JSON.parse(config);
            $(flickis[i]).flickity(config);
          } catch {}
        }
      }
      try {
        childDidReMountAsyncOverrides();

        let anyProps: any = this.props;
        let mywindow: any = window;
        let searchString: string = mywindow.location.search;
        if (
          (searchString.includes('showCookieBanner=false') ||
            searchString.includes('widerrufsformular') ||
            searchString.includes('gewaehrleistung')) &&
          mywindow.historyHelper.cookieBaner != undefined
        ) {
          mywindow.historyHelper.cookieBaner.showBanner(false);
        }
      } catch {}
    }, 100);

    try {
      let anyProps: any = this.props;
      let newUrl = reactUrlToBrowserUrl(
        anyProps.location.pathname,
        anyProps.location.search,
        this.state.apiData,
      );

      if (newUrl != undefined && newUrl != '') {
        let anyWin: any = window;
        let browserHistory = anyWin.historyHelper.browser;
        let oldUrl =
          browserHistory.location.pathname + browserHistory.location.search;

        document.title = this.getTitle();

        let safeUtl = newUrl;
        try {
          decodeURI(safeUtl);
        } catch (error2) {
          safeUtl = umcodeURL(newUrl);
        }

        decodeURI(safeUtl);

        if (newUrl != '' && oldUrl != newUrl) {
          browserHistory.push(safeUtl, null);
          anyWin.scrollTo(0, 0);
        }
      }
    } catch (error) {
      try {
        let windowAny: any = window;

        if (
          windowAny.historyHelper != undefined &&
          windowAny.historyHelper.pushError != undefined
        ) {
          windowAny.historyHelper.pushError('BasePage.ReplaceURI', error);
        }
      } catch (error2) {}
    }

    this.childDidMount();
  }

  componentWillUnmount() {
    if (this.checkModeIntervalHandle != undefined)
      clearInterval(this.checkModeIntervalHandle);
    if (this.apiDataCoruptRestart != undefined) {
      clearTimeout(this.apiDataCoruptRestart);
      this.apiDataCoruptRestart = undefined;
    }
    this.childDidUnmount();
  }

  checkMode() {
    let width = 0;
    if (this.mainContainer != null && this.mainContainer != undefined) {
      let dummy: any = this.mainContainer;
      let cur_dummy: any = dummy.current;
      width = cur_dummy.offsetWidth;
    }

    let newMode: PageMode = PageMode.Desktop;
    if (width <= 767) newMode = PageMode.Mobile;
    else if (width <= 1000) newMode = PageMode.Tablet;
    if (this.state.mode != newMode) this.setState({ mode: newMode });
  }

  render() {
    let hasApiData = this.state.hasApiData;

    if (hasApiData && this.props.mode == 'react') {
      let validUrl = this.getApiReqestUrl();

      validUrl = validUrl.substr(this.state.apiBase.length);

      validUrl = validUrl.trim();

      let apiDatataUrl = this.state.apiData.apiRequestUri;

      let fixArray = [
        { s: '%2F', r: '___' },
        { s: '//', r: '/' },
      ];

      validUrl = replaceAllComplex(validUrl, fixArray);
      validUrl = encodeURI(validUrl);

      apiDatataUrl = replaceAllComplex(apiDatataUrl, fixArray);

      apiDatataUrl = replaceAllComplex(apiDatataUrl, [
        { s: '%3A', r: '%253A' },
        { s: '%2C', r: ',' },
        { s: '%27', r: "'" },
        //{ s: '%C3%', r: '%25C3%' },
        //{ s: '%9C%', r: '%259C%25' },
      ]);

      validUrl = replaceAllComplex(validUrl, [
        { s: '%252C', r: '%2C' },
        { s: '%25C3', r: '%C3' },
        { s: '%259C', r: '%9C' },
        { s: '%253F', r: '%3F' },
        { s: '%25BC', r: '%BC' },
        { s: '%253A', r: ':' },
        { s: '%255C', r: '%5C' },
      ]);

      if (validUrl != apiDatataUrl) {
        let valid2Url = replaceAllComplex(validUrl, [
          { s: '%2527', r: '%27' },
          { s: '%2525', r: '%25' },
          { s: '%25', r: '%' },
          { s: '%2C', r: ',' },
        ]);
        let apiDatata2Url = replaceAllComplex(apiDatataUrl, [
          { s: '%25', r: '%' },
        ]);
        if (valid2Url != apiDatata2Url) {
          hasApiData = false;
          if (this.apiDataCoruptRestart == undefined) {
            this.apiDataCoruptRestart = setTimeout(() => {
              console.log({
                validUrl: validUrl,
                apiDatataUrl: apiDatataUrl,

                valid2Url: valid2Url,
                apiDatata2Url: apiDatata2Url,
              });
              this.setState({ hasApiData: false, apiData: null });
              this.fetchApiData();
              this.apiDataCoruptRestart = undefined;
            }, 1000);
          }
        }
      }
    }

    let resetKey = this.state.apiData?.apiRequestUri;

    let childPart = hasApiData ? (
      <ErrorBoundary name="renderChild" resetKey={resetKey}>
        <ChildRenderer render={() => this.renderChild()} />
      </ErrorBoundary>
    ) : (
      <Loading />
    );

    let showPartner = this.getType() != 'ShoppingCartPage';
    let showSearch = true;
    if (
      true && //this.state.mode == PageMode.Mobile &&
      this.getType() == 'ShoppingCartPage'
    ) {
      showSearch = false;
    }

    let stateInfo = {
      articleCount: undefined,
      isLogin: undefined,
      articlePreis: undefined,
    };

    if (hasApiData) {
      stateInfo = this.state.apiData;
    }

    let showBreadCrumb = true;

    if (this.state.mode == PageMode.Mobile) showBreadCrumb = false;

    if (
      showBreadCrumb &&
      (this.getType() == 'SearchPage' ||
        this.getType() == 'StartPage' ||
        this.getType() == 'ContainerPage')
    )
      showBreadCrumb = false;

    let footerLinks = [];
    if (this.state?.apiData?.footerLinks != null) {
      footerLinks = this.state.apiData.footerLinks;
    }

    let cookieDomain = '';
    let cookieConfig = undefined;

    let customCss = '';

    if (this.state.hasApiData) {
      cookieDomain = this.state.apiData.cookieDomain;
      cookieConfig = this.state.apiData.cookieConfig;
      customCss = this.state.apiData.customCss;
    }

    return (
      <>
        <div id="mobileMenuContainer">
          <ErrorBoundary name="MobileMenu" silent resetKey={resetKey}>
            <Menu
              domainPrefix={this.state.renderingDomain}
              isMobil={true}
              kalenderJahr={this.state?.apiData?.kalenderJahr}
            />
          </ErrorBoundary>
        </div>
        <div id="main-container" ref={this.mainContainer}>
          <div id="headerSection">
            <ErrorBoundary name="HeaderMoluna" silent resetKey={resetKey}>
              <HeaderMoluna
                domainPrefix={this.state.renderingDomain}
                articleCount={stateInfo.articleCount}
                articlePreis={stateInfo.articlePreis}
                isLogin={stateInfo.isLogin}
                showSearch={showSearch}
              ></HeaderMoluna>
            </ErrorBoundary>
            <ErrorBoundary name="Menu" silent resetKey={resetKey}>
              <Menu
                domainPrefix={this.state.renderingDomain}
                isMobil={false}
                kalenderJahr={this.state?.apiData?.kalenderJahr}
              />
            </ErrorBoundary>
            {showBreadCrumb ? (
              <ErrorBoundary name="BreadCrumb" silent resetKey={resetKey}>
                <ChildRenderer
                  render={() => (
                    <BreadCrumb
                      domainPrefix={this.state.renderingDomain}
                      rightItem={this.getRightBreadCrumbParts()}
                    >
                      {this.getBreadCrumb()}
                    </BreadCrumb>
                  )}
                />
              </ErrorBoundary>
            ) : null}
          </div>
        </div>
        <div id="bodySection">{childPart}</div>
        <br className="clearBoth" />

        <div id="footerSection">
          <ErrorBoundary name="FooterMoluna" silent resetKey={resetKey}>
            <FooterMoluna
              domainPrefix={this.state.renderingDomain}
              showPartnerDiv={showPartner}
              footerLinks={footerLinks}
            />
          </ErrorBoundary>
        </div>
        <div
          id="trustbadgeCustomContainer"
          style={{ position: 'fixed', bottom: '100px' }}
        ></div>

        <ErrorBoundary name="CookieManager" silent resetKey={resetKey}>
          <CookieManager
            cookieDomain={cookieDomain}
            cookieName="__cmpcvcu11149"
            cookieData={cookieConfig}
            domainPrefix={this.state.renderingDomain}
          />
        </ErrorBoundary>
        <style>{customCss}</style>
      </>
    );
  }
  abstract getBreadCrumb(): JSX.Element;

  abstract getType(): string;
}

export function startPopup() {
  window.document.body.classList.add('noScroll');
  $('#cmpboxrecall').hide();
  $('div').filter((index: number, element: HTMLElement) => {
    if (!element.id.startsWith('trustbadge-container')) return false;
    $(element).hide();
    return true;
  });
}

export function endPopup() {
  window.document.body.classList.remove('noScroll');

  $('#cmpboxrecall').show();
}
